import React from 'react';
import PropTypes from 'prop-types';
import WidgetContainer from 'components/widget/WidgetContainer';
import TwoColsWidgetLayout from 'layouts/TwoColsWidgetLayout';
import { ReactComponent as StockPilingSvg } from 'images/stockpiling.svg';
import TextLink from 'components/TextLink';
import CTAIconWrapper from 'components/widget/CTAIconWrapper';

const SkipPackWidget = ({ className, packId }) => {
  const classes = ['SkipPackWidget', className];

  return (
    <WidgetContainer className={classes.filter((c) => !!c).join(' ')}>
      <TwoColsWidgetLayout>
        <div>
          <h2 className="no_margin_top">Lenses starting to pile up?</h2>
          <TextLink rightChevron props={{ to: `/orders/${packId}/skip` }}>Skip your next delivery</TextLink>
        </div>
        <CTAIconWrapper>
          <StockPilingSvg />
        </CTAIconWrapper>
      </TwoColsWidgetLayout>
    </WidgetContainer>
  );
};

SkipPackWidget.displayName = 'SkipPackWidget';

SkipPackWidget.propTypes = {
  className: PropTypes.string,
  packId: PropTypes.string.isRequired,
};

SkipPackWidget.defaultProps = {
  className: null,
};

export default SkipPackWidget;
